<template>
  <div>
    <b-card title="لیست پیام ها">
      <div>
        <b-row>
          <div class="col-md-6">
            <user-list v-model="params.user_id"></user-list>
          </div>
          <div class="col-md-6">
            <b-form-group
              id="input-group-1"
              label="متن پیام: "
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="params.description"
                placeholder="متن پیام "
              ></b-form-input>
            </b-form-group>
          </div>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="mr-3" variant="success" @click="searchMessage"
              >جستجو</b-button
            >
             <b-button class="mr-3" variant="success" href="#/AddMessage"
              >پیام جدید</b-button
            >
          </b-col>
        </b-row>

        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="datas"
        >
        </b-table>
        <b-button-group v-if="page_count > 1">
          <b-button @click="searchMessage(1)"
            ><i class="flaticon2-next"></i
          ></b-button>
          <b-button
            v-for="page in pages"
            v-bind:key="page"
            @click="searchMessage(page)"
            :variant="page == current_page ? 'success' : 'default'"
            >{{ page }}</b-button
          >
          <b-button @click="searchMessage(page_count)"
            ><i class="flaticon2-back"></i
          ></b-button>
        </b-button-group>
      </div>
    </b-card>
  </div>
</template>


<script>
import httpHelper from "@/helpers/httpHelper";
import UserList from "../../components/UserList";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import persianDate from "../../helpers/persianDate";

export default {
  name: "messages",
  components: {
    "user-list": UserList,
  },
  data: function () {
    return {
      fields: [
        {
          key: "id",
          label: "شناسه پیام",
        },
        {
          key: "description",
          label: "متن",
        },
        {
          key: "dismissible",
          label: "نحوه نمایش",
           formatter: (value, key, item) => {
            return (value == 0)? 'نمایش دایمی':'نمایش برای یکبار';
          },
        },
        {
          key: "type",
          label: "نوع",
           formatter: (value, key, item) => {
            return (value == 'success')? 'موفق':'خطا';
          },
        },
        {
          key: "date_seen",
          label: "تاریخ بازدید",
           formatter: (value, key, item) => {
            return (value)?persianDate.getDate(value):'-';
          },
        },
        {
          key: "user.name",
          label: "کاربر ",
        },
        {
          key: "user.mobile",
          label: "موبایل ",
        },
        {
          key: "created_at",
          label: "تاریخ",
          formatter: (value, key, item) => {
            return persianDate.getDate(value);
          },
        },
      
      ],
      datas: [],
      pages: [],
      current_page: 0,
      page_count: 0,
      params: [
        {
          user_id:null,
          description:""
        },
        
      ],
    };
  },
created() {
      httpHelper.setAuth();

    this.searchMessage();
  },
  methods: {
    createPager(last_page, current_page) {
      this.pages = [];
      this.current_page = current_page;
      var startPageer = this.current_page > 5 ? this.current_page - 4 : 0;
      var endPageer = last_page > 5 ? this.current_page + 3 : last_page;
      this.page_count = last_page;
      if (this.current_page + 3 > this.page_count) {
        endPageer = this.page_count;
      }
      for (let i = startPageer; i < endPageer; i++) {
        this.pages.push(i + 1);
      }
    },

    searchMessage: function (page = 1) {
        var params1 = "";
        if (this.params.user_id) {
          params1 += "&user_id=" + this.params.user_id;
        }
        if (this.params.description) {
          params1 += "&description=" + this.params.description;
        }
        httpHelper
          .getData("message" + "?page=" + page + params1)
          .then((res) => {
            if (res.success) {
              this.datas = res.result.data;
              this.createPager(res.result.last_page, res.result.current_page);
            } else {
            }
          })
          .catch((error) => {})
          .finally(() => {});
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست پیام ها" }]);
    },
  },
};
</script>